















import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation, namespace } from "vuex-class";
import fileTabCard from "@/components/layouts/fileTabCard.vue";
import _ from "lodash";

const CollectionModule = namespace("CollectionModule");

@Component({
  components: {
    fileTabCard,
  },
})
export default class FileTab extends Vue {
  @CollectionModule.State("fileList") fileList: any;
  @CollectionModule.Action("loadFiles") loadFiles: any;

  keyword = "";

  mounted() {
    this.load(true);
    this.addScrollEvent(this.scrollView);
  }

  async load(clear: boolean) {
    const keyword = this.keyword;
    this.loadFiles({ clear, keyword });
  }

  get scrollView() {
    return this.$refs.scrollView as any;
  }

  addScrollEvent(scrollView: any) {
    scrollView.addEventListener("scroll", this.throttle);
  }

  destroyed() {
    this.destroyScrollEvent(this.scrollView);
  }

  destroyScrollEvent(scrollView: any) {
    scrollView.removeEventListener("scroll", this.throttle);
  }

  onSearch(keyword: string, event: any) {
    this.keyword = keyword;
    this.load(true);
  }

  handleScroll() {
    const scrollTop = (this.scrollView && this.scrollView.scrollTop) || this.scrollView.scrollTop;
    const bottomOfWindow = scrollTop + this.scrollView.clientHeight;

    if (this.scrollView.scrollHeight - bottomOfWindow < 150) {
      this.load(false);
    }
  }

  throttle = _.throttle(this.handleScroll, 500);
}
